import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FundingToken, PaymentDetails } from "src/app/models/dmv/models";
import { PaymentDevice } from "src/app/models/user/paymentDevice";
import { PaymentDevices } from "src/app/models/user/paymentDevices";
import { DMVDataService } from "src/app/services/dmv/dmv-data.service";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppConfigUtil } from "src/app/utils/app-config.util";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-select-payment-method",
	templateUrl: "./select-payment-method.component.html",
	styleUrls: ["./select-payment-method.component.css"]
})
export class SelectPaymentMethodComponent implements OnInit {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public userStoreService: USERStoreService,
		private formBuilder: FormBuilder,
		public dmvStoreService: DMVStoreService,
		public userDataService: USERDataService,
		public megStoreService: MEGStoreService,
		public dmvDataService: DMVDataService,
		private cd: ChangeDetectorRef
	) {}

	public submitted = false;
	public paymentMethodForm: FormGroup;
	public errorMessage: string = "";
	public isloading: boolean = false;
	public sucessMessage: string = "";
	public paymentDevices: PaymentDevices;
	ngOnInit() {
		this.isloading = true;
		this.userDataService
			.getPaymentDevices(
				this.dmvStoreService.selectedAgencyId,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"SelectPaymentMethodComponent getPaymentDevice() ==> response:",
						response
					);
					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.paymentDevices = response.paymentDevices;
						}
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log(
						"SelectPaymentMethodComponent getPaymentDevice() error:",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);

		this.paymentMethodForm = this.formBuilder.group({
			paymentMethod: ["", Validators.required]
		});
	}

	public get f() {
		return this.paymentMethodForm.controls;
	}

	public cancel() {
		this.back();
	}
	public back() {
		this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
	}
	public submit() {
		this.errorMessage = "";
		this.submitted = true;
		if (this.paymentMethodForm.invalid) {
			this.errorMessage = "Please select a payment method.";
			console.log("save notification.invalid");
			return;
		}

		if (
			this.paymentMethodForm.controls.paymentMethod.value ===
			"NEW_PAYMENT_METHOD"
		) {
			if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.serviceProviderID ===
				2
			) {
				this.router.navigate(["gsg-payment"], { skipLocationChange: true });
			} else if (
				this.dmvStoreService.agencyConfig.agencyDmvConfig.serviceProviderID ===
				3
			) {
				this.router.navigate(["meg-payment"], {
					skipLocationChange: true
				});
			} else {
				if (
					AppConfigUtil.getProperties() &&
					AppConfigUtil.getProperties().DirectWebComponentAccess &&
					AppConfigUtil.getProperties().DirectWebComponentAccess === true
				) {
					this.router.navigate(["pnp-payment"], { skipLocationChange: true });
				} else {
					this.router.navigate(["payment"], { skipLocationChange: true });
				}
			}
		} else {
			let paymentDetails: PaymentDevices;
			if (
				this.userStoreService.getUserProfile() &&
				this.userStoreService.getUserProfile().paymentDevices
			) {
				const _this = this;
				paymentDetails = this.userStoreService
					.getUserProfile()
					.paymentDevices.filter(function(item) {
						return (
							item.fundingToken ===
							_this.paymentMethodForm.controls.paymentMethod.value
						);
					});
				this.updatedPaymenetDetails(paymentDetails[0]);
				this.callRenewApi(
					this.dmvStoreService.registrationsInCart.renewalRequest,
					this.dmvStoreService.selectedAgencyId
				);
			}
		}
	}

	public callRenewApi(renewalRequest, agencyID) {
		AppUtil.log(
			"SelectPaymentMethodComponent callRenewApi() ==>  renewalRequest, agencyID: ",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getRenewalResponse(
				renewalRequest,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					if (response) {
						AppUtil.log(
							"SelectPaymentMethodComponent callRenewApi() ==>  response: ",
							response
						);
						if (response.statusCode === 202) {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC: RNC)";
							this.isloading = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						} else {
							this.dmvStoreService.registrationsInCart.renewalToken =
								response.renewalToken;
							this.getServiceFees();
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"SelectPaymentMethodComponent callRenewApi() ==>  error: ",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: RNC)";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public getServiceFees() {
		AppUtil.log("SelectPaymentMethodComponent getServiceFees() ==>");
		const renewalToken = this.dmvStoreService.registrationsInCart.renewalToken;
		const agencyID = this.dmvStoreService.selectedAgencyId;
		this.dmvDataService
			.getServiceFeesResponse(
				renewalToken,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"SelectPaymentMethodComponent getServiceFees() ==> response",
						response
					);
					if (response) {
						this.isloading = false;
						this.cd.markForCheck();
						this.dmvStoreService.registrationsInCart.serviceFeeAmount =
							response.serviceFeeAmount;

						this.router.navigate(["dmv-review-cart-with-billing"], {
							skipLocationChange: true
						});
					}
				},
				error => {
					AppUtil.log(
						"SelectPaymentMethodComponent getServiceFees() ==> error",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: FEE)";
						this.isloading = false;
						this.cd.markForCheck();
						window.scroll(0, 0);
					}
				}
			);
	}

	private updatedPaymenetDetails(data: PaymentDevice) {
		AppUtil.log(
			"SelectPaymentMethodComponent updatedPaymenetDetails() ==> data: ",
			data
		);
		const paymentDetails: PaymentDetails = new Object({});
		const fundingToken: FundingToken = new Object({});
		fundingToken.billingAddress = new Object({});
		//paymentDetails.fundingToken = new Object({});
		const firstName = data.firstName;
		if (firstName) {
			fundingToken.billingFirstName = firstName;
		}

		const lastName = data.lastName;
		if (lastName) {
			fundingToken.billingLastName = lastName;
		}

		let addressLine1 = data.address ? data.address.line1 : null;
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			fundingToken.billingAddress.line1 = addressLine1;
		}

		let addressLine2 = data.address ? data.address.line2 : null;
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			fundingToken.billingAddress.line2 = addressLine2;
		}

		const stateCode = data.address ? data.address.stateCode : null;
		if (stateCode) {
			fundingToken.billingAddress.stateCode = stateCode;
		}
		const nonUsRegion = data.address ? data.address.nonUsRegion : null;
		if (nonUsRegion) {
			fundingToken.billingAddress.nonUsRegion = nonUsRegion;
		}

		const postalCode = data.address ? data.address.postalCode : null;
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.billingAddress.postalCode = postalCode;
		}

		const city = data.address ? data.address.city : null;
		if (city) {
			fundingToken.billingAddress.city = city;
		}

		const country = data.address ? data.address.countryCode : null;
		if (country) {
			fundingToken.billingAddress.countryCode = country;
		}

		const last4 = data.accountLast4;
		if (last4) {
			fundingToken.accountLast4 = last4;
		}

		const nameOnAccount = data.nameOnAccount;
		if (nameOnAccount) {
			fundingToken.nameOnAccount = nameOnAccount;
		}

		const phone = data.phone;
		if (phone) {
			fundingToken.billingPhone = phone;
		}

		const emailAddress = data.emailAddress;
		if (emailAddress) {
			fundingToken.billingEmailAddress = emailAddress;
		}

		const paymentMethod = data.paymentMethod;
		if (paymentMethod) {
			fundingToken.paymentMethod = paymentMethod;
		}

		const cardBrand = data.cardBrand;
		if (cardBrand) {
			fundingToken.cardBrand = cardBrand;
		} else {
			if (paymentMethod === "Electronic Check") {
				fundingToken.cardBrand = "EC";
			}
		}

		const token = data.fundingToken;
		if (token) {
			fundingToken.fundingToken = token;
		}

		paymentDetails.fundingToken = fundingToken;
		this.dmvStoreService.registrationsInCart.renewalRequest.fundingToken = token;
		this.dmvStoreService.paymentDetails = paymentDetails;
		AppUtil.log(
			"PaymentDetailsComponent updatedPaymenetDetails() ==> paymentDetails: ",
			paymentDetails
		);
	}
}
